import { ISpaceTypeInfo } from '../../models/resourceInfoParts';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IGetMetricsForLuidsParams } from '../types/IGetMetricsForLuidsParams';
import { IMetricWithSummaryData } from '../types/IMetricWithSummaryData';
import { Request } from './Request';

export type GetMetricsForLuidsParams = IGetMetricsForLuidsParams;

export interface IGetMetricsForLuidsResult extends IGetItemsResult {
  metrics?: IMetricWithSummaryData[];
}

export class GetMetricsWithSummaryDataForLuidsRequest extends Request<GetMetricsForLuidsParams, IGetMetricsForLuidsResult> {
  constructor(params: GetMetricsForLuidsParams) {
    super('getMetricsWithSummaryDataForLuids', params);
  }
}
